<template>
    <div class="time-line-style">
        <div class="time-line-style-area">
            <Timeline>
                <template v-for="(item,index) in cloudBoardList">
                    <TimelineItem>
                        <!--月份-->
                        <p class="time-line-month">{{item.date}}</p>
                        <template v-for="(subItem,subIndex) in item.list">
                            <!--内容-->
                            <div class="time-line-content">
                                <!--缩略图-->
                                <img class="time-line-content-img" :src="subItem.thumbnail"
                                     v-on:click="previewImg(subItem.thumbnail,subIndex)">
                                <p class="time-line-content-text">时间：{{subItem.update_time}}</p>
                                <p class="time-line-content-text">来源：{{subItem.source_type}}</p>
                            </div>
                        </template>
                    </TimelineItem>
                </template>
            </Timeline>
            <div class="laypage_main">
                <Page
                    :total="total"
                    :current="page"
                    :page-size="limit"
                    @on-change="handleCurrentChange"
                    v-show="total && pageCount>1"
                    show-total
                />
            </div>
        </div>
        <!--&lt;!&ndash; 预览轮播 &ndash;&gt;-->
        <!--<preview-slider-->
            <!--ref="previewSlider"-->
            <!--:previewMode="previewMode"-->
            <!--:previewVideoMode="previewVideoMode"-->
            <!--:videoSrc="videoSrc"-->
            <!--@closePreview="closePreview"-->
        <!--&gt;</preview-slider>-->

        <!-- 预览轮播 -->
        <dt-preview-slider
                ref="previewSlider"
                :previewMode="previewMode"
                :previewVideoMode="previewVideoMode"
                :videoSrc="videoSrc"
                @closePreview="closePreview"
        ></dt-preview-slider>
    </div>
</template>

<script>
    import {findUserWhiteBoardDetailList} from "../../../service/api.js";

    // const previewSlider = () => import("../../dashboard/table/baseData/previewSlider");

    export default {
        name: "user-board-details",
        data () {
            return {
                userId: this.$route.query.userId,//用户ID
                cloudBoardList: [],//使用云白板集合
                previewMode: false,
                previewVideoMode: false,
                videoSrc: "",
                page: 1,
                limit: 10,
                pageCount: 0,
                total: 0
            }
        },
        // components: {
        //     previewSlider
        // },
        methods: {
            handleCurrentChange (val) {
                this.page = val;
                this.queryUserWhiteBoardDetailList();
            },
            /**
             * 预览图片
             */
            previewImg (img, index) {
                this.previewMode = true;
                //处理图片集合
                this.$refs.previewSlider.swiperInitByImgArr(this.convertImgArr(img), index);
            },
            // 关闭预览
            closePreview (type) {
                this[type] = false;
            },
            /**
             *处理图片集合
             */
            convertImgArr (img) {
                let imgArrData = [];
                let imgObj = {};
                imgObj.url = img;
                imgArrData.push(imgObj);
                return imgArrData;
            },
            /**
             *获取学校白班统计
             */
            async queryUserWhiteBoardDetailList () {
                let _this = this;
                let params = {
                    userId: _this.userId,
                    keyWord: _this.keyWord,
                    page: _this.page,
                    limit: _this.limit
                };
                await findUserWhiteBoardDetailList(params)
                    .then(function (data) {
                        if (Object.keys(data).length !== 0) {
                            let resultData = data.rows;
                            for (let i = 0; i < resultData.length; i++) {
                                resultData[i].month = resultData[i].update_time.substring(0, 4) + '年' + resultData[i].update_time.substring(5, 7) + '月';
                                //将日期转换为时间戳
                                resultData[i].publishTimeNew = _this.dateToTime(resultData[i].update_time);
                            }
                            //按降序排序
                            resultData.sort(function (a, b) {
                                return b.publishTimeNew > a.publishTimeNew ? 1 : -1;
                            });
                            _this.cloudBoardList = _this.groupBykey(resultData, 'month');
                            _this.total = data.total_rows;
                            _this.pageCount = Math.ceil(data.total_rows / _this.limit);
                        }
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 将日期转换为时间戳
             */
            dateToTime (str) {
                return (new Date(str.replace(/-/g, '/'))).getTime(); //用/替换日期中的-是为了解决Safari的兼容
            },
            /**
             *根据月份对数据进行分类
             */
            groupBykey (list, fieldName) {
                let dataMap = {};
                let dataList = [];
                for (let i = 0; i < list.length; i++) {
                    let ai = list[i];
                    if (!dataMap[ai[fieldName]]) {
                        dataList.push({
                            date: ai[fieldName],
                            month: ai[fieldName].substring(5, 7),
                            list: [ai]
                        });
                        dataMap[ai[fieldName]] = ai;
                    } else {
                        for (let j = 0; j < dataList.length; j++) {
                            let dj = dataList[j];
                            if (dj.date === ai[fieldName]) {
                                dj.list.push(ai);
                                break;
                            }
                        }
                    }
                }
                return dataList;
            }
        },
        mounted () {
            this.queryUserWhiteBoardDetailList();
        }
    }
</script>

<style lang="scss" scoped>
    .time-line-month {
        margin-top: -4px;
        font-size: 18px;
        font-weight: bold;
    }

    .time-line-content-img {
        padding-left: 5px;
        width: 250px;
    }

    .time-line-content-text {
        padding-left: 5px;
        padding-top: 10px;
        font-size: 16px;
    }

    .time-line-style {
        padding-left: 100px;
        padding-top: 100px;
    }

    .time-line-content {
        display: inline-block;
        padding: 20px;
    }
    .ivu-timeline-item-content {
        text-align: left !important;
    }
    .time-line-style-area{
        position: relative;
        .laypage_main{
            position: absolute;
            right: 50px;
            bottom: 10px;
        }
    }
</style>
<style lang="scss">
    .ivu-timeline-item-content {
        text-align: left !important;
    }
</style>
